module.exports = __webpack_public_path__ + "static/media/wowmix (5).54071bab.jpg";